import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface RouteFocusManagerProps {
  containerId: string;
}

const RouteFocusManager: React.FC<RouteFocusManagerProps> = ({
  containerId,
}) => {
  const location = useLocation();

  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container) return;

    let observer: MutationObserver | null = null;

    const focusRouteTarget = () => {
      const target =
        container.querySelector<HTMLElement>("[data-route-focus-priority]") ??
        container.querySelector<HTMLElement>("[data-route-focus]");

      if (!target) return false;

      target.focus({ preventScroll: false });
      return true;
    };

    if (focusRouteTarget()) return;

    observer = new MutationObserver(() => {
      if (!focusRouteTarget()) return;
      observer?.disconnect();
      observer = null;
    });
    observer.observe(container, { childList: true, subtree: true });

    return () => {
      observer?.disconnect();
    };
  }, [
    containerId,
    location.hash,
    location.pathname,
    location.search,
  ]);

  return null;
};

export default RouteFocusManager;
